import React from 'react';
import { FormGroup, FormField, Message } from 'semantic-ui-react';

import { QUESTIONS, TRIAGE_QUESTION_ID } from '../fixtures';

import type { SharedProps } from './shared';

/**
 * Wake County flow: PM confirmation required before continuing.
 * If No to PM confirm, survey stops with message to connect via Slack.
 */
export const WakeCountySection: React.FC<SharedProps> = ({ handleQuestion, getAnswer }) => {
  const q51 = getAnswer(TRIAGE_QUESTION_ID.WAKE_COUNTY_GATE);
  const q52 = getAnswer(TRIAGE_QUESTION_ID.WAKE_PM_SLACK_CONFIRM);

  return (
    <>
      <FormGroup grouped>
        <label>{QUESTIONS[TRIAGE_QUESTION_ID.WAKE_COUNTY_GATE].questionText}</label>
        <FormField
          label={QUESTIONS[TRIAGE_QUESTION_ID.WAKE_COUNTY_GATE].options[0]}
          control="input"
          type="radio"
          name="wakeCounty"
          checked={q51 === QUESTIONS[TRIAGE_QUESTION_ID.WAKE_COUNTY_GATE].options[0]}
          onChange={() => handleQuestion(TRIAGE_QUESTION_ID.WAKE_COUNTY_GATE, QUESTIONS[TRIAGE_QUESTION_ID.WAKE_COUNTY_GATE].options[0])}
        />
        <FormField
          label={QUESTIONS[TRIAGE_QUESTION_ID.WAKE_COUNTY_GATE].options[1]}
          control="input"
          type="radio"
          name="wakeCounty"
          checked={q51 === QUESTIONS[TRIAGE_QUESTION_ID.WAKE_COUNTY_GATE].options[1]}
          onChange={() => handleQuestion(TRIAGE_QUESTION_ID.WAKE_COUNTY_GATE, QUESTIONS[TRIAGE_QUESTION_ID.WAKE_COUNTY_GATE].options[1])}
        />
      </FormGroup>

      {q51 === 'Yes' && (
        <>
          <FormGroup grouped>
            <label>{QUESTIONS[TRIAGE_QUESTION_ID.WAKE_PM_SLACK_CONFIRM].questionText}</label>
            <FormField
              label={QUESTIONS[TRIAGE_QUESTION_ID.WAKE_PM_SLACK_CONFIRM].options[0]}
              control="input"
              type="radio"
              name="pmConfirm"
              checked={q52 === QUESTIONS[TRIAGE_QUESTION_ID.WAKE_PM_SLACK_CONFIRM].options[0]}
              onChange={() => handleQuestion(TRIAGE_QUESTION_ID.WAKE_PM_SLACK_CONFIRM, QUESTIONS[TRIAGE_QUESTION_ID.WAKE_PM_SLACK_CONFIRM].options[0])}
            />
            <FormField
              label={QUESTIONS[TRIAGE_QUESTION_ID.WAKE_PM_SLACK_CONFIRM].options[1]}
              control="input"
              type="radio"
              name="pmConfirm"
              checked={q52 === QUESTIONS[TRIAGE_QUESTION_ID.WAKE_PM_SLACK_CONFIRM].options[1]}
              onChange={() => handleQuestion(TRIAGE_QUESTION_ID.WAKE_PM_SLACK_CONFIRM, QUESTIONS[TRIAGE_QUESTION_ID.WAKE_PM_SLACK_CONFIRM].options[1])}
            />
          </FormGroup>

          {q52 === 'No' && (
            <Message info>
              <Message.Header>Note</Message.Header>
              <p>Please check in with PM via Slack prior to submitting survey.</p>
            </Message>
          )}
        </>
      )}
    </>
  );
};
